module.exports = __webpack_public_path__ + "static/media/bont.e6d6d8eb.png";